package com.eladfinish.bible.contest.utils

import com.eladfinish.bible.contest.constants.Constants
import com.russhwolf.settings.Settings
import dev.icerock.moko.resources.desc.StringDesc

// The language the app starts in until the user picks another one, as on Android.
private const val DEFAULT_LANGUAGE_CODE = "iw"

/** The language the app's texts are shown in on this page load. */
var currentAppLanguageCode: String = DEFAULT_LANGUAGE_CODE
    private set

/**
 * The Settings screen has already stored [languageCode] under [Constants.PREF_LANGUAGE] by the
 * time it calls this, and reloads the page right after (`AppActions.restartApp()`); the reloaded
 * page picks the language up in [applySavedLanguage].
 */
actual fun applyLanguageChange(languageCode: String) {
    currentAppLanguageCode = languageCode
    StringDesc.localeType = StringDesc.LocaleType.Custom(languageCode.toBcp47Language())
}

/** Applies the language chosen in Settings. Called once at startup, before the app is mounted. */
fun applySavedLanguage(settings: Settings) {
    applyLanguageChange(settings.getString(key = Constants.PREF_LANGUAGE, defaultValue = DEFAULT_LANGUAGE_CODE))
}

/** "iw" is the legacy code the app stores for Hebrew; browsers and moko-resources expect "he". */
fun String.toBcp47Language(): String = if (this == "iw") "he" else this
